import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/employees")({
  staticData: { breadcrumb: { label: "sidebar.employees" } },
  component: () => <Outlet />,
});
